export default {
    name: 'single-product',
    _container: null,
    _retailers: null,
    init()
    {
        this.initToggleDescription();
        this.initToggleDetails();
        this.initToggleEquipmentList();
    },

    initToggleDescription()
    {
        const el = document.getElementById('js_toggleProductDescription');

        if (el) {
            el.addEventListener('click', function() {
                const targetEl = document.getElementById('js_productDescription');
                targetEl.classList.toggle('active');
                const scrollTo = targetEl.closest('.box-inner');

                setTimeout(function(){
                    scrollTo.scrollIntoView({block: "start", behavior: "smooth"})
                }, 500);
            })
        }
    },

    initToggleDetails()
    {
        const el = document.getElementById('js_toggleProductDetails');

        if (el) {
            el.addEventListener('click', function() {
                document.getElementById('js_productDetails').classList.toggle('active');
            })
        }
    },


    initToggleEquipmentList()
    {
        const el = document.getElementById('js_toggleEquipmentList');

        if (el) {
            el.addEventListener('click', function() {
                document.getElementById('js_equipmentList').classList.toggle('active');
            })
        }
    },
}